import { useState, useEffect } from "react";
import ProjectsGrid from './Projects';

// ── Brand tokens ──────────────────────────────────────────────────────────────
const T = {
  teal:"#1D9E75", tealL:"#E1F5EE", tealD:"#085041",
  purple:"#7F77DD", purpleL:"#EEEDFE", purpleD:"#3C3489",
  amber:"#EF9F27", amberL:"#FAEEDA", amberD:"#633806",
  coral:"#D85A30", coralL:"#FAECE7", coralD:"#712B13",
};

const PHASE_META = {
  seed:      { label:"Seed",      week:1, color:T.teal,   bg:T.tealL,   fg:T.tealD,   icon:"ti-plant" },
  cultivate: { label:"Cultivate", week:2, color:T.purple, bg:T.purpleL, fg:T.purpleD, icon:"ti-growth" },
  refine:    { label:"Refine",    week:3, color:T.amber,  bg:T.amberL,  fg:T.amberD,  icon:"ti-pencil" },
  release:   { label:"Release",   week:4, color:T.coral,  bg:T.coralL,  fg:T.coralD,  icon:"ti-rocket" },
};

const THEME_META = {
  community:   { color:"#378ADD", bg:"#E6F1FB", fg:"#0C447C" },
  healing:     { color:"#D4537E", bg:"#FBEAF0", fg:"#72243E" },
  meditation:  { color:T.purple,  bg:T.purpleL, fg:T.purpleD },
  "music+sound":{ color:T.teal,   bg:T.tealL,   fg:T.tealD },
  movement:    { color:T.amber,   bg:T.amberL,  fg:T.amberD },
  creativity:  { color:T.coral,   bg:T.coralL,  fg:T.coralD },
  spirit:      { color:"#639922", bg:"#EAF3DE", fg:"#27500A" },
};

const SUBS  = ["Website","IVR","Community","Studio","Admin","Outreach"];
const AIMS  = ["Engage","Heal","Connect","Create","Sustain","Grow"];
const SRCS  = ["zoom","trello","discord","manual","figma","drive"];
const STATS = ["todo","doing","done"];

const SRC_META = {
  zoom:    { l:"Zoom",    bg:T.purpleL, fg:T.purpleD, icon:"ti-video" },
  trello:  { l:"Trello",  bg:T.tealL,   fg:T.tealD,   icon:"ti-layout-kanban" },
  discord: { l:"Discord", bg:T.purpleL, fg:T.purple,   icon:"ti-brand-discord" },
  manual:  { l:"Manual",  bg:"#F1EFE8", fg:"#444441",  icon:"ti-pencil" },
  figma:   { l:"Figma",   bg:"#FBEAF0", fg:"#72243E",  icon:"ti-vector-bezier" },
  drive:   { l:"Drive",   bg:"#EAF3DE", fg:"#27500A",  icon:"ti-brand-google-drive" },
};

const AIM_META = {
  Engage:  { bg:T.tealL,   fg:T.tealD },
  Heal:    { bg:"#FBEAF0", fg:"#72243E" },
  Connect: { bg:T.purpleL, fg:T.purpleD },
  Create:  { bg:T.amberL,  fg:T.amberD },
  Sustain: { bg:"#EAF3DE", fg:"#27500A" },
  Grow:    { bg:"#E6F1FB", fg:"#0C447C" },
};

const SUB_COLOR = {
  Website:"#1D9E75", IVR:"#7F77DD", Community:"#D4537E",
  Studio:"#EF9F27",  Admin:"#378ADD", Outreach:"#D85A30",
};

const PRI_META = {
  high: { l:"High", bg:"#FCEBEB", fg:"#791F1F" },
  med:  { l:"Med",  bg:T.amberL,  fg:T.amberD },
  low:  { l:"Low",  bg:"#F1EFE8", fg:"#5F5E5A" },
};

const COL_META = {
  todo:  { l:"To do", dot:"#E24B4A", bg:"#FCEBEB", fg:"#791F1F" },
  doing: { l:"Doing", dot:T.amber,   bg:T.amberL,  fg:T.amberD },
  done:  { l:"Done",  dot:T.teal,    bg:T.tealL,   fg:T.tealD },
};

// ── Rebrand project seed ──────────────────────────────────────────────────────
// Phase 1 – Foundation (Weeks 1–4)
const SEED = [
  // Week 1 – Seed
  { id:1,  title:"Deliver strategy document",            sub:"Admin",     aim:"Sustain", src:"manual", st:"todo",  who:"",   pri:"high", tid:"", date:"2026-07-13", cyclePhase:"seed",      cycleWeek:1, phaseLabel:"Phase 1 – Foundation" },
  { id:2,  title:"Deliver brand kit",                    sub:"Website",   aim:"Create",  src:"figma",  st:"todo",  who:"",   pri:"high", tid:"", date:"2026-07-13", cyclePhase:"seed",      cycleWeek:1, phaseLabel:"Phase 1 – Foundation" },
  { id:3,  title:"Deliver dashboard wireframe",          sub:"Website",   aim:"Create",  src:"figma",  st:"done",  who:"AK", pri:"high", tid:"", date:"2026-07-12", cyclePhase:"seed",      cycleWeek:1, phaseLabel:"Phase 1 – Foundation" },
  { id:4,  title:"Deliver EPK visuals",                  sub:"Website",   aim:"Create",  src:"figma",  st:"todo",  who:"",   pri:"med",  tid:"", date:"2026-07-13", cyclePhase:"seed",      cycleWeek:1, phaseLabel:"Phase 1 – Foundation" },
  { id:5,  title:"Receive sprint plan + wireframes",     sub:"Admin",     aim:"Sustain", src:"manual", st:"todo",  who:"",   pri:"high", tid:"", date:"2026-07-13", cyclePhase:"seed",      cycleWeek:1, phaseLabel:"Phase 1 – Foundation" },
  { id:6,  title:"Receive library Storytime link",       sub:"Community", aim:"Connect", src:"manual", st:"todo",  who:"",   pri:"med",  tid:"", date:"2026-07-13", cyclePhase:"seed",      cycleWeek:1, phaseLabel:"Phase 1 – Foundation" },
  // Week 2 – Cultivate
  { id:7,  title:"Build modular code base",              sub:"Website",   aim:"Create",  src:"trello", st:"todo",  who:"AK", pri:"high", tid:"T-010", date:"2026-07-20", cyclePhase:"cultivate", cycleWeek:2, phaseLabel:"Phase 1 – Foundation" },
  { id:8,  title:"Build component library",              sub:"Website",   aim:"Create",  src:"figma",  st:"doing", who:"AK", pri:"high", tid:"T-011", date:"2026-07-20", cyclePhase:"cultivate", cycleWeek:2, phaseLabel:"Phase 1 – Foundation" },
  { id:9,  title:"Begin dashboard landing page",         sub:"Website",   aim:"Engage",  src:"trello", st:"doing", who:"AK", pri:"high", tid:"T-012", date:"2026-07-20", cyclePhase:"cultivate", cycleWeek:2, phaseLabel:"Phase 1 – Foundation" },
  // Week 3 – Refine
  { id:10, title:"Integrate brand kit into UI components",sub:"Website",  aim:"Create",  src:"figma",  st:"todo",  who:"",   pri:"high", tid:"", date:"2026-07-27", cyclePhase:"refine",    cycleWeek:3, phaseLabel:"Phase 1 – Foundation" },
  { id:11, title:"Align on pillar navigation",           sub:"Website",   aim:"Connect", src:"manual", st:"todo",  who:"",   pri:"med",  tid:"", date:"2026-07-27", cyclePhase:"refine",    cycleWeek:3, phaseLabel:"Phase 1 – Foundation" },
  { id:12, title:"Review dashboard progress",            sub:"Admin",     aim:"Sustain", src:"zoom",   st:"todo",  who:"",   pri:"med",  tid:"", date:"2026-07-27", cyclePhase:"refine",    cycleWeek:3, phaseLabel:"Phase 1 – Foundation" },
  // Week 4 – Release
  { id:13, title:"Finalize dashboard MVP",               sub:"Website",   aim:"Grow",    src:"trello", st:"todo",  who:"AK", pri:"high", tid:"T-013", date:"2026-08-03", cyclePhase:"release",   cycleWeek:4, phaseLabel:"Phase 1 – Foundation" },
  { id:14, title:"Prepare livestream test structure",    sub:"Studio",    aim:"Create",  src:"manual", st:"todo",  who:"",   pri:"high", tid:"", date:"2026-08-03", cyclePhase:"release",   cycleWeek:4, phaseLabel:"Phase 1 – Foundation" },
  { id:15, title:"Prepare pilot interview structure",    sub:"Community", aim:"Engage",  src:"manual", st:"todo",  who:"",   pri:"med",  tid:"", date:"2026-08-03", cyclePhase:"release",   cycleWeek:4, phaseLabel:"Phase 1 – Foundation" },
  { id:16, title:"Technical prep: IVR + AI agent",       sub:"IVR",       aim:"Connect", src:"trello", st:"doing", who:"TW", pri:"high", tid:"T-014", date:"2026-08-03", cyclePhase:"release",   cycleWeek:4, phaseLabel:"Phase 1 – Foundation" },
];

let nextId = 17;
const blank = () => ({ title:"", sub:"Website", aim:"Engage", src:"manual", pri:"med", who:"", tid:"", docLink:"", cyclePhase:"seed", cycleWeek:1, phaseLabel:"Phase 1 – Foundation" });

// ── Cycle context helper ──────────────────────────────────────────────────────
const CYCLE_START = new Date("2026-07-06");
function getCycleContext(date = new Date()) {
  const elapsed    = date - CYCLE_START;
  const dayInCycle = Math.floor((elapsed % (28*864e5)) / 864e5);
  const cycleWeek  = Math.floor(dayInCycle / 7) + 1;
  const phases     = ["seed","cultivate","refine","release"];
  const cyclePhase = phases[Math.min(cycleWeek-1, 3)];
  const themes     = ["community","healing","meditation","music+sound","movement","creativity","spirit"];
  const dailyTheme = themes[date.getDay()];
  return { cycleWeek, cyclePhase, dailyTheme };
}

// ── Shared styles ─────────────────────────────────────────────────────────────
const S = {
  card:    { background:"var(--surface-2, #ffffff)", border:"0.5px solid var(--border, #e0ddd6)", borderRadius:10, padding:"12px 14px" },
  input:   { padding:"7px 10px", borderRadius:8, border:"1px solid var(--border-strong, #c9c5ba)", background:"var(--surface-2, #ffffff)", color:"var(--text-primary, #2f2f2f)", fontSize:13, width:"100%" },
  sel:     { padding:"7px 8px",  borderRadius:8, border:"1px solid var(--border-strong, #c9c5ba)", background:"var(--surface-2, #ffffff)", color:"var(--text-primary, #2f2f2f)", fontSize:13, width:"100%", cursor:"pointer" },
  pillSel: { padding:"4px 10px", borderRadius:20, border:"1px solid var(--border-strong, #c9c5ba)", background:"var(--surface-2, #ffffff)", color:"var(--text-secondary, #5f5e5a)", fontSize:11, cursor:"pointer" },
  lbl:     { fontSize:10, fontWeight:500, letterSpacing:".06em", textTransform:"uppercase", color:"var(--text-muted, #8a8782)", marginBottom:5 },
  badge:   (bg, fg) => ({ display:"inline-flex", alignItems:"center", gap:3, padding:"2px 8px", borderRadius:4, fontSize:10, fontWeight:500, background:bg, color:fg, whiteSpace:"nowrap" }),
  pbtn:    { padding:"6px 14px", borderRadius:8, background:T.teal, border:"none", color:"#fff", fontSize:12, cursor:"pointer", fontWeight:500, display:"flex", alignItems:"center", gap:5 },
  sbtn:    { padding:"5px 10px", borderRadius:8, background:"transparent", border:"1px solid var(--border-strong, #c9c5ba)", color:"var(--text-secondary, #5f5e5a)", fontSize:12, cursor:"pointer" },
  // Distinct, high-contrast wrapper specifically for "Add ___" panels —
  // deliberately not the same as S.card, so forms visually pop against
  // the page rather than blending into it.
  formPanel: { background:"#ffffff", border:"1px solid #d8d5cc", borderRadius:12, padding:16, boxShadow:"0 2px 10px rgba(0,0,0,0.06)" },
};

function Badge({ bg, fg, icon, label }) {
  return (
    <span style={S.badge(bg, fg)}>
      {icon && <i className={`ti ${icon}`} style={{ fontSize:10 }} aria-hidden="true" />}
      {label}
    </span>
  );
}

// ── Phase banner ──────────────────────────────────────────────────────────────
function CycleBanner({ ctx }) {
  const pm = PHASE_META[ctx.cyclePhase];
  const tm = THEME_META[ctx.dailyTheme] || {};
  return (
    <div style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 12px",
      background:pm.bg, borderRadius:8, marginBottom:14, flexWrap:"wrap" }}>
      <i className={`ti ${pm.icon}`} style={{ fontSize:15, color:pm.color }} aria-hidden="true" />
      <span style={{ fontSize:12, fontWeight:500, color:pm.fg }}>
        Week {pm.week} · {pm.label}
      </span>
      <span style={{ fontSize:11, color:pm.fg, opacity:.7 }}>Phase 1 – Foundation</span>
      <span style={{ marginLeft:"auto", ...S.badge(tm.bg||pm.bg, tm.fg||pm.fg) }}>
        Today: {ctx.dailyTheme}
      </span>
    </div>
  );
}

// ── Task card ─────────────────────────────────────────────────────────────────
function TaskCard({ task, expanded, onToggle, onDelete, onMove, onEdit }) {
  const [editing, setEditing] = useState(false);
  const [draft,   setDraft]   = useState({});
  const [confirmDelete, setConfirmDelete] = useState(false);

  const sm = SRC_META[task.src] || SRC_META.manual;
  const am = AIM_META[task.aim] || { bg:"#F1EFE8", fg:"#5F5E5A" };
  const pm = PRI_META[task.pri] || PRI_META.med;
  const sc = SUB_COLOR[task.sub] || "#888";
  const ph = PHASE_META[task.cyclePhase];

  const startEdit = e => {
    e.stopPropagation();
    setDraft({ ...task });
    setEditing(true);
  };

  const saveEdit = e => {
    e.stopPropagation();
    onEdit(draft);
    setEditing(false);
  };

  const cancelEdit = e => {
    e.stopPropagation();
    setEditing(false);
  };

  const handleDelete = e => {
    e.stopPropagation();
    if (confirmDelete) { onDelete(); }
    else { setConfirmDelete(true); setTimeout(() => setConfirmDelete(false), 3000); }
  };

  return (
    <div className="task-card" draggable={!editing}
      onDragStart={e => e.dataTransfer.setData("taskId", task.id)}
      onClick={editing ? undefined : onToggle}
      style={{ ...S.card, borderLeft:`3px solid ${sc}`, borderRadius:"0 10px 10px 0",
        marginBottom:7, cursor: editing ? "default" : "pointer", transition:"border-color .12s" }}>

      {/* ── Card header ── */}
      <div style={{ display:"flex", alignItems:"flex-start", gap:6, marginBottom:7 }}>
        <i className="ti ti-grip-vertical" style={{ fontSize:13, color:"var(--text-muted)", flexShrink:0, marginTop:1 }} aria-hidden="true" />
        <span style={{ fontSize:12, fontWeight:500, color:"var(--text-primary)", flex:1, lineHeight:1.5 }}>
          {task.title}
        </span>
        <div style={{ display:"flex", gap:4, flexShrink:0 }} onClick={e => e.stopPropagation()}>
          <button onClick={startEdit}
            style={{ background:"none", border:"none", cursor:"pointer", color:"var(--text-muted)", padding:"0 2px", fontSize:13 }}
            aria-label="Edit ticket" title="Edit">
            <i className="ti-pencil" aria-hidden="true" />
          </button>
          <button onClick={handleDelete}
            style={{ background:"none", border:"none", cursor:"pointer",
              color: confirmDelete ? "#E24B4A" : "var(--text-muted)", padding:"0 2px", fontSize:13,
              fontWeight: confirmDelete ? 600 : 400 }}
            aria-label="Delete ticket" title={confirmDelete ? "Click again to confirm" : "Delete"}>
            {confirmDelete
              ? <span style={{ fontSize:10 }}>confirm?</span>
              : <i className="ti ti-trash" aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* ── Badges (collapsed view) ── */}
      {!editing && (
        <div style={{ display:"flex", flexWrap:"wrap", gap:4 }}>
          <Badge bg={sm.bg} fg={sm.fg} icon={sm.icon} label={sm.l} />
          <Badge bg={am.bg} fg={am.fg} label={task.aim} />
          <Badge bg={pm.bg} fg={pm.fg} label={pm.l} />
          {ph && <Badge bg={ph.bg} fg={ph.fg} label={`W${task.cycleWeek}`} />}
          {task.who && (
            <span style={{ ...S.badge(T.purpleL, T.purpleD), gap:4 }}>
              <span style={{ width:14, height:14, borderRadius:"50%", background:T.purple,
                display:"inline-flex", alignItems:"center", justifyContent:"center",
                fontSize:8, color:"#fff", fontWeight:600, flexShrink:0 }}>
                {task.who.slice(0,2).toUpperCase()}
              </span>
              {task.who}
            </span>
          )}
          {task.docLink && (
            <a href={task.docLink} target="_blank" rel="noreferrer"
              onClick={e => e.stopPropagation()}
              style={{ ...S.badge("#E6F1FB","#0C447C"), gap:3, textDecoration:"none" }}>
              <i className="ti ti-link" style={{ fontSize:10 }} aria-hidden="true" />doc
            </a>
          )}
        </div>
      )}

      {/* ── Inline edit form ── */}
      {editing && (
        <div onClick={e => e.stopPropagation()}
          style={{ borderTop:"0.5px solid var(--border)", paddingTop:10, marginTop:4 }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:10 }}>
            <div style={{ gridColumn:"1/-1" }}>
              <div style={S.lbl}>Title</div>
              <input autoFocus style={S.input} value={draft.title}
                onChange={e => setDraft(d => ({ ...d, title:e.target.value }))} />
            </div>
            <div>
              <div style={S.lbl}>Subsystem</div>
              <select style={S.sel} value={draft.sub} onChange={e => setDraft(d => ({ ...d, sub:e.target.value }))}>
                {SUBS.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <div style={S.lbl}>Aim</div>
              <select style={S.sel} value={draft.aim} onChange={e => setDraft(d => ({ ...d, aim:e.target.value }))}>
                {AIMS.map(a => <option key={a}>{a}</option>)}
              </select>
            </div>
            <div>
              <div style={S.lbl}>Priority</div>
              <select style={S.sel} value={draft.pri} onChange={e => setDraft(d => ({ ...d, pri:e.target.value }))}>
                <option value="high">High</option>
                <option value="med">Med</option>
                <option value="low">Low</option>
              </select>
            </div>
            <div>
              <div style={S.lbl}>Status</div>
              <select style={S.sel} value={draft.st} onChange={e => setDraft(d => ({ ...d, st:e.target.value }))}>
                <option value="todo">To do</option>
                <option value="doing">Doing</option>
                <option value="done">Done</option>
              </select>
            </div>
            <div>
              <div style={S.lbl}>Phase week</div>
              <select style={S.sel} value={draft.cycleWeek} onChange={e => {
                const w = +e.target.value;
                const phases = ["seed","cultivate","refine","release"];
                setDraft(d => ({ ...d, cycleWeek:w, cyclePhase:phases[w-1] }));
              }}>
                <option value={1}>Week 1 – Seed</option>
                <option value={2}>Week 2 – Cultivate</option>
                <option value={3}>Week 3 – Refine</option>
                <option value={4}>Week 4 – Release</option>
              </select>
            </div>
            <div>
              <div style={S.lbl}>Assignee</div>
              <input style={S.input} placeholder="Name or initials" value={draft.who}
                onChange={e => setDraft(d => ({ ...d, who:e.target.value }))} />
            </div>
            <div style={{ gridColumn:"1/-1" }}>
              <div style={S.lbl}>Document link</div>
              <input style={S.input} placeholder="https://docs.google.com/…" value={draft.docLink || ""}
                onChange={e => setDraft(d => ({ ...d, docLink:e.target.value }))} />
            </div>
            <div style={{ gridColumn:"1/-1" }}>
              <div style={S.lbl}>Notes</div>
              <textarea style={{ ...S.input, minHeight:56, resize:"vertical" }} value={draft.notes || ""}
                onChange={e => setDraft(d => ({ ...d, notes:e.target.value }))} />
            </div>
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={saveEdit} style={S.pbtn}>Save</button>
            <button onClick={cancelEdit} style={S.sbtn}>Cancel</button>
          </div>
        </div>
      )}

      {/* ── Expanded read view ── */}
      {expanded && !editing && (
        <div onClick={e => e.stopPropagation()}
          style={{ borderTop:"0.5px solid var(--border)", paddingTop:10, marginTop:8 }}>
          <div style={{ display:"grid", gridTemplateColumns:"auto 1fr", rowGap:5, columnGap:14, marginBottom:10, fontSize:11 }}>
            <span style={{ color:"var(--text-muted)" }}>Subsystem</span>
            <span style={{ fontWeight:500, color:sc }}>{task.sub}</span>
            <span style={{ color:"var(--text-muted)" }}>Phase</span>
            <span style={{ color:"var(--text-secondary)" }}>{task.phaseLabel || "—"} · Week {task.cycleWeek}</span>
            <span style={{ color:"var(--text-muted)" }}>Assignee</span>
            <span style={{ color: task.who ? T.purple : "var(--text-muted)", fontStyle: task.who ? "normal" : "italic" }}>
              {task.who || "unassigned"}
            </span>
            {task.docLink && <>
              <span style={{ color:"var(--text-muted)" }}>Document</span>
              <a href={task.docLink} target="_blank" rel="noreferrer"
                style={{ color:"#0C447C", fontSize:11, display:"flex", alignItems:"center", gap:3 }}>
                <i className="ti ti-external-link" style={{ fontSize:11 }} aria-hidden="true" />
                {task.docLink.length > 40 ? task.docLink.slice(0,40) + "…" : task.docLink}
              </a>
            </>}
            <span style={{ color:"var(--text-muted)" }}>Date</span>
            <span style={{ color:"var(--text-secondary)" }}>{task.date}</span>
            {task.notes && <>
              <span style={{ color:"var(--text-muted)", alignSelf:"flex-start" }}>Notes</span>
              <span style={{ color:"var(--text-secondary)", lineHeight:1.5 }}>{task.notes}</span>
            </>}
          </div>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
            {STATS.filter(s => s !== task.st).map(s => (
              <button key={s} onClick={() => onMove(s)}
                style={{ ...S.sbtn, fontSize:11 }}>
                Move to {COL_META[s].l}
              </button>
            ))}
            <button onClick={startEdit}
              style={{ ...S.sbtn, fontSize:11, marginLeft:"auto", display:"flex", alignItems:"center", gap:4 }}>
              <i className="ti-pencil" style={{ fontSize:11 }} aria-hidden="true" />Edit
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Kanban column ─────────────────────────────────────────────────────────────
function KanbanColumn({ status, tasks, totalCount, expandId, onToggle, onDelete, onMove, onEdit, onDrop }) {
  const [over, setOver] = useState(false);
  const meta = COL_META[status];
  return (
    <div onDragOver={e => { e.preventDefault(); setOver(true); }}
      onDragLeave={e => { if (!e.currentTarget.contains(e.relatedTarget)) setOver(false); }}
      onDrop={e => { e.preventDefault(); onDrop(e.dataTransfer.getData("taskId")); setOver(false); }}
      style={{ background: over ? "var(--surface-1)" : "transparent", borderRadius:12,
        border:`0.5px solid ${over ? "var(--border-strong)" : "var(--border)"}`,
        minHeight:200, paddingBottom:8, transition:"all .12s" }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, padding:"12px 12px 10px" }}>
        <div style={{ width:9, height:9, borderRadius:"50%", background:meta.dot, flexShrink:0 }} />
        <span style={{ fontSize:13, fontWeight:500, color:"var(--text-primary)" }}>{meta.l}</span>
        <span style={{ padding:"1px 8px", borderRadius:4, fontSize:11, fontWeight:500,
          background:meta.bg, color:meta.fg }}>{totalCount}</span>
      </div>
      <div style={{ padding:"0 8px" }}>
        {tasks.length === 0 && (
          <div style={{ padding:"18px 10px", textAlign:"center", color:"var(--text-muted)",
            fontSize:12, border:"0.5px dashed var(--border-strong)", borderRadius:8 }}>
            Drop here
          </div>
        )}
        {tasks.map(t => (
          <TaskCard key={t.id} task={t} expanded={expandId === t.id}
            onToggle={() => onToggle(t.id)} onDelete={() => onDelete(t.id)}
            onMove={s => onMove(t.id, s)} onEdit={onEdit} />
        ))}
      </div>
    </div>
  );
}

// ── Add task form ─────────────────────────────────────────────────────────────
function AddTaskForm({ onAdd, onCancel, cycleCtx }) {
  const [f, setF] = useState({
    ...blank(),
    cyclePhase: cycleCtx.cyclePhase,
    cycleWeek:  cycleCtx.cycleWeek,
  });

  return (
    <div style={{ ...S.formPanel, marginBottom:14 }}>
      <div style={{ fontSize:13, fontWeight:500, color:"var(--text-primary, #2f2f2f)", marginBottom:12,
        display:"flex", alignItems:"center", gap:6 }}>
        <i className="ti ti-plus" style={{ fontSize:15, color:T.teal }} aria-hidden="true" />New ticket
      </div>
      <form onSubmit={e => {
        e.preventDefault();
        if (!f.title.trim()) return;
        onAdd({ ...f, id:nextId++, st:"todo", date:new Date().toISOString().slice(0,10) });
      }}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
          <div style={{ gridColumn:"1/-1" }}>
            <div style={S.lbl}>Title</div>
            <input autoFocus required style={S.input} placeholder="Describe the task…"
              value={f.title} onChange={e => setF(p => ({ ...p, title:e.target.value }))} />
          </div>
          <div>
            <div style={S.lbl}>Subsystem</div>
            <select style={S.sel} value={f.sub} onChange={e => setF(p => ({ ...p, sub:e.target.value }))}>
              {SUBS.map(s => <option key={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <div style={S.lbl}>Aim</div>
            <select style={S.sel} value={f.aim} onChange={e => setF(p => ({ ...p, aim:e.target.value }))}>
              {AIMS.map(a => <option key={a}>{a}</option>)}
            </select>
          </div>
          <div>
            <div style={S.lbl}>Source</div>
            <select style={S.sel} value={f.src} onChange={e => setF(p => ({ ...p, src:e.target.value }))}>
              {SRCS.map(s => <option key={s} value={s}>{SRC_META[s].l}</option>)}
            </select>
          </div>
          <div>
            <div style={S.lbl}>Priority</div>
            <select style={S.sel} value={f.pri} onChange={e => setF(p => ({ ...p, pri:e.target.value }))}>
              <option value="high">High</option>
              <option value="med">Med</option>
              <option value="low">Low</option>
            </select>
          </div>
          <div>
            <div style={S.lbl}>Phase week</div>
            <select style={S.sel} value={f.cycleWeek} onChange={e => {
              const w = +e.target.value;
              const phases = ["seed","cultivate","refine","release"];
              setF(p => ({ ...p, cycleWeek:w, cyclePhase:phases[w-1] }));
            }}>
              <option value={1}>Week 1 – Seed</option>
              <option value={2}>Week 2 – Cultivate</option>
              <option value={3}>Week 3 – Refine</option>
              <option value={4}>Week 4 – Release</option>
            </select>
          </div>
          <div>
            <div style={S.lbl}>Assignee</div>
            <input style={S.input} placeholder="Name or initials" value={f.who}
              onChange={e => setF(p => ({ ...p, who:e.target.value }))} />
          </div>
          <div>
            <div style={S.lbl}>Trello ID</div>
            <input style={S.input} placeholder="T-0XX" value={f.tid}
              onChange={e => setF(p => ({ ...p, tid:e.target.value }))} />
          </div>
          <div style={{ gridColumn:"1/-1" }}>
            <div style={S.lbl}>Document link <span style={{ color:"var(--text-muted)", fontWeight:400, textTransform:"none", letterSpacing:0 }}>(optional — Google Doc, Figma, Drive…)</span></div>
            <input style={S.input} placeholder="https://docs.google.com/…" value={f.docLink}
              onChange={e => setF(p => ({ ...p, docLink:e.target.value }))} />
          </div>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button type="submit" style={S.pbtn}>Add ticket</button>
          <button type="button" onClick={onCancel} style={S.sbtn}>Cancel</button>
        </div>
      </form>
    </div>
  );
}

// ── Grant feedback tab ────────────────────────────────────────────────────────
const GRANT_SEED = [
  { id:1, funder:"NEA",        category:"Tech",      severity:"high", status:"open",     note:"Revisit data methodology section",           applies:true  },
  { id:2, funder:"Hewlett",    category:"Programs",  severity:"med",  status:"resolved", note:"Clarify evaluation timeline",                applies:false },
  { id:3, funder:"Zellerbach", category:"Budget",    severity:"low",  status:"open",     note:"Line items need more granularity",            applies:true  },
  { id:4, funder:"CA Arts",    category:"Narrative", severity:"high", status:"open",     note:"Community impact needs more voices",          applies:true  },
];

function GrantsTab() {
  const [items, setItems]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [fSev,  setFSev]      = useState("all");
  const [fSt,   setFSt]       = useState("all");
  const [search, setSearch]   = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm]       = useState({ funder:"", category:"", severity:"med", status:"open", note:"", applies:false });

  // DB feedback_item row -> local shape (funder comes from the joined proposal)
  const mapItem = (row, funderName) => ({
    id: row.id,
    funder: funderName || row.funder || "",
    category: row.category,
    severity: row.severity,
    status: row.status,
    note: row.item,
    applies: !!row.appliesToOtherFunders,
    proposalId: row.proposalId,
  });

  useEffect(() => {
    Promise.all([
      fetch('/api/proposals').then(r => r.ok ? r.json() : { proposals: [] }),
      fetch('/api/feedback-items').then(r => r.ok ? r.json() : { feedbackItems: [] }),
    ]).then(([proposalsData, feedbackData]) => {
      const proposals = proposalsData.proposals || [];
      const proposalById = Object.fromEntries(proposals.map(p => [p.id, p.funder || p.title]));
      const rows = feedbackData.feedbackItems || [];
      setItems(rows.map(row => mapItem(row, proposalById[row.proposalId])));
      setLoading(false);
    }).catch(err => { console.error('Failed to load grants data:', err); setLoading(false); });
  }, []);

  // Find a proposal matching this funder, or create one on the fly
  const findOrCreateProposal = async funder => {
    const res = await fetch('/api/proposals');
    const data = res.ok ? await res.json() : { proposals: [] };
    const existing = (data.proposals || []).find(p => (p.funder || p.title) === funder);
    if (existing) return existing.id;
    const createRes = await fetch('/api/proposals', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: funder, funder, status: 'draft' }),
    });
    const createData = await createRes.json();
    return createData.proposal?.id;
  };

  const addItem = async f => {
    try {
      const proposalId = await findOrCreateProposal(f.funder);
      const res = await fetch('/api/feedback-items', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          proposalId, item: f.note, category: f.category,
          severity: f.severity, appliesToOtherFunders: f.applies,
        }),
      });
      const data = await res.json();
      if (data.feedbackItem) setItems(is => [mapItem(data.feedbackItem, f.funder), ...is]);
    } catch (err) {
      console.error('Failed to add feedback item:', err);
    }
    setForm({ funder:"", category:"", severity:"med", status:"open", note:"", applies:false });
    setShowAdd(false);
  };

  const vis = items.filter(i => {
    if (fSev !== "all" && i.severity !== fSev) return false;
    if (fSt  !== "all" && i.status   !== fSt)  return false;
    if (search && !i.funder.toLowerCase().includes(search.toLowerCase()) && !i.note.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const toggle = id => {
    const current = items.find(i => i.id === id);
    const newStatus = current.status === "open" ? "resolved" : "open";
    setItems(is => is.map(i => i.id===id ? {...i, status:newStatus} : i)); // optimistic
    fetch(`/api/feedback-items/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: newStatus }),
    }).catch(err => console.error('Failed to update feedback item:', err));
  };
  const del = id => {
    setItems(is => is.filter(i => i.id !== id)); // optimistic
    fetch(`/api/feedback-items/${id}`, { method: 'DELETE' })
      .catch(err => console.error('Failed to delete feedback item:', err));
  };
  const SEV = { high:{ bg:"#FCEBEB",fg:"#791F1F" }, med:{bg:T.amberL,fg:T.amberD}, low:{bg:"#F1EFE8",fg:"#5F5E5A"} };
  const STA = { open:{bg:T.amberL,fg:T.amberD}, resolved:{bg:T.tealL,fg:T.tealD} };

  if (loading) {
    return <div style={{ padding:"32px 0", textAlign:"center", color:"var(--text-muted, #8a8782)", fontSize:13 }}>Loading grant feedback…</div>;
  }

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginBottom:14 }}>
        <div style={{ flex:1, position:"relative" }}>
          <i className="ti ti-search" style={{ position:"absolute", left:9, top:"50%", transform:"translateY(-50%)", fontSize:13, color:"var(--text-muted)", pointerEvents:"none" }} aria-hidden="true" />
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search funders or notes…"
            style={{ ...S.input, paddingLeft:30, background:"var(--surface-1)" }} />
        </div>
        <select style={S.pillSel} value={fSev} onChange={e=>setFSev(e.target.value)}>
          <option value="all">All severity</option><option value="high">High</option><option value="med">Med</option><option value="low">Low</option>
        </select>
        <select style={S.pillSel} value={fSt} onChange={e=>setFSt(e.target.value)}>
          <option value="all">All status</option><option value="open">Open</option><option value="resolved">Resolved</option>
        </select>
        <button onClick={()=>setShowAdd(v=>!v)} style={S.pbtn}>
          <i className="ti ti-plus" style={{ fontSize:13 }} aria-hidden="true" />Add feedback
        </button>
      </div>
      {showAdd && (
        <div style={{ ...S.formPanel, marginBottom:14 }}>
          <form onSubmit={e=>{e.preventDefault();addItem(form);}}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
              <div><div style={S.lbl}>Funder</div><input required style={S.input} value={form.funder} onChange={e=>setForm(p=>({...p,funder:e.target.value}))}/></div>
              <div><div style={S.lbl}>Category</div><input required style={S.input} value={form.category} onChange={e=>setForm(p=>({...p,category:e.target.value}))}/></div>
              <div><div style={S.lbl}>Severity</div>
                <select style={S.sel} value={form.severity} onChange={e=>setForm(p=>({...p,severity:e.target.value}))}>
                  <option value="high">High</option><option value="med">Med</option><option value="low">Low</option>
                </select>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:8, paddingTop:20 }}>
                <input type="checkbox" id="applies" checked={form.applies} onChange={e=>setForm(p=>({...p,applies:e.target.checked}))}/>
                <label htmlFor="applies" style={{ fontSize:12, color:"var(--text-secondary)" }}>Applies to other funders</label>
              </div>
              <div style={{ gridColumn:"1/-1" }}><div style={S.lbl}>Feedback note</div>
                <input required style={S.input} value={form.note} onChange={e=>setForm(p=>({...p,note:e.target.value}))}/>
              </div>
            </div>
            <div style={{ display:"flex", gap:8 }}>
              <button type="submit" style={S.pbtn}>Add</button>
              <button type="button" onClick={()=>setShowAdd(false)} style={S.sbtn}>Cancel</button>
            </div>
          </form>
        </div>
      )}
      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {vis.map(item=>(
          <div key={item.id} style={{ ...S.card, display:"flex", alignItems:"flex-start", gap:12 }}>
            <div style={{ flex:1 }}>
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
                <span style={{ fontSize:13, fontWeight:500, color:"var(--text-primary)" }}>{item.funder}</span>
                <Badge bg={SEV[item.severity].bg} fg={SEV[item.severity].fg} label={item.severity} />
                <Badge bg={STA[item.status].bg}   fg={STA[item.status].fg}   label={item.status} />
                {item.applies && <Badge bg="#E6F1FB" fg="#0C447C" label="Applies broadly" />}
              </div>
              <div style={{ fontSize:11, color:T.teal, fontWeight:500, marginBottom:3 }}>{item.category}</div>
              <div style={{ fontSize:12, color:"var(--text-secondary)", lineHeight:1.5 }}>{item.note}</div>
            </div>
            <div style={{ display:"flex", gap:6, flexShrink:0 }}>
              <button onClick={()=>toggle(item.id)} style={{ ...S.sbtn, fontSize:11 }}>{item.status==="open"?"Resolve":"Reopen"}</button>
              <button onClick={()=>del(item.id)} style={{ ...S.sbtn, fontSize:11, color:"#E24B4A" }}>
                <i className="ti ti-trash" style={{ fontSize:13 }} aria-hidden="true" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Partnerships tab ──────────────────────────────────────────────────────────
const PARTNER_SEED = [
  { id:1, org:"Oakland Public Library", stage:"active",   contact:"M. Torres",  next:"2026-08-01", notes:"Storytime series — 6 sessions confirmed" },
  { id:2, org:"KPFA Radio",             stage:"prospect", contact:"D. Williams",next:"2026-07-20", notes:"Intro call scheduled" },
  { id:3, org:"Oakland Unified",        stage:"active",   contact:"R. Chen",    next:"2026-09-05", notes:"Fall semester workshop series" },
  { id:4, org:"Yerba Buena Arts",       stage:"proposal", contact:"A. Grant",   next:"2026-07-25", notes:"Proposal submitted" },
  { id:5, org:"Black Cultural Zone",    stage:"prospect", contact:"J. Davis",   next:"2026-07-30", notes:"Meeting set with program director" },
];
const STAGE_ORDER = ["outreach","prospect","proposal","active","paused"];
const STAGE_META  = {
  outreach:{ bg:"#F1EFE8", fg:"#5F5E5A", dot:"#888780" },
  prospect:{ bg:T.amberL,  fg:T.amberD,  dot:T.amber },
  proposal:{ bg:T.purpleL, fg:T.purpleD, dot:T.purple },
  active:  { bg:T.tealL,   fg:T.tealD,   dot:T.teal },
  paused:  { bg:"#FCEBEB", fg:"#791F1F",  dot:"#E24B4A" },
};

function PartnershipsTab() {
  const [partners, setPartners] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [fStage,   setFStage]   = useState("all");
  const [search,   setSearch]   = useState("");
  const [showAdd,  setShowAdd]  = useState(false);
  const [form, setForm]         = useState({ org:"", stage:"prospect", contact:"", next:"", notes:"" });

  // DB row -> local shape
  const mapPartner = row => ({
    id: row.id,
    org: row.orgName,
    stage: row.stage || "prospect",
    contact: row.contactName || "",
    next: row.nextActionDate ? row.nextActionDate.slice(0, 10) : "",
    notes: row.notes || "",
  });

  useEffect(() => {
    fetch('/api/partnerships', { credentials: 'include' })
      .then(r => r.ok ? r.json() : { partnerships: [] })
      .then(data => { setPartners((data.partnerships || []).map(mapPartner)); setLoading(false); })
      .catch(err => { console.error('Failed to load partnerships:', err); setLoading(false); });
  }, []);

  const addPartner = f => {
    fetch('/api/partnerships', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orgName: f.org, stage: f.stage, contactName: f.contact,
        nextActionDate: f.next || null, notes: f.notes,
      }),
    })
      .then(r => r.json())
      .then(data => { if (data.partnership) setPartners(ps => [mapPartner(data.partnership), ...ps]); })
      .catch(err => console.error('Failed to add partnership:', err));
    setForm({ org:"", stage:"prospect", contact:"", next:"", notes:"" });
    setShowAdd(false);
  };

  const vis = partners.filter(p=>{
    if(fStage!=="all"&&p.stage!==fStage)return false;
    if(search&&!p.org.toLowerCase().includes(search.toLowerCase()))return false;
    return true;
  });
  const move = (id,stage) => {
    setPartners(ps=>ps.map(p=>p.id===id?{...p,stage}:p)); // optimistic
    fetch(`/api/partnerships/${id}`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ stage }),
    }).catch(err => console.error('Failed to move partnership:', err));
  };
  const del = id => {
    setPartners(ps=>ps.filter(p=>p.id!==id)); // optimistic
    fetch(`/api/partnerships/${id}`, { method: 'DELETE', credentials: 'include' })
      .catch(err => console.error('Failed to delete partnership:', err));
  };
  const byStage = stage=>vis.filter(p=>p.stage===stage);

  if (loading) {
    return <div style={{ padding:"32px 0", textAlign:"center", color:"var(--text-muted, #8a8782)", fontSize:13 }}>Loading partnerships…</div>;
  }

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginBottom:14 }}>
        <div style={{ flex:1, position:"relative" }}>
          <i className="ti ti-search" style={{ position:"absolute", left:9, top:"50%", transform:"translateY(-50%)", fontSize:13, color:"var(--text-muted)", pointerEvents:"none" }} aria-hidden="true" />
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search organizations…"
            style={{ ...S.input, paddingLeft:30, background:"var(--surface-1)" }} />
        </div>
        <select style={S.pillSel} value={fStage} onChange={e=>setFStage(e.target.value)}>
          <option value="all">All stages</option>
          {STAGE_ORDER.map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
        </select>
        <button onClick={()=>setShowAdd(v=>!v)} style={S.pbtn}>
          <i className="ti ti-plus" style={{ fontSize:13 }} aria-hidden="true" />Add partner
        </button>
      </div>
      {showAdd&&(
        <div style={{ ...S.formPanel, marginBottom:14 }}>
          <form onSubmit={e=>{e.preventDefault();addPartner(form);}}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
              <div><div style={S.lbl}>Organization</div><input required style={S.input} value={form.org} onChange={e=>setForm(p=>({...p,org:e.target.value}))}/></div>
              <div><div style={S.lbl}>Stage</div>
                <select style={S.sel} value={form.stage} onChange={e=>setForm(p=>({...p,stage:e.target.value}))}>
                  {STAGE_ORDER.map(s=><option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
                </select>
              </div>
              <div><div style={S.lbl}>Contact</div><input style={S.input} value={form.contact} onChange={e=>setForm(p=>({...p,contact:e.target.value}))}/></div>
              <div><div style={S.lbl}>Next action</div><input type="date" style={S.input} value={form.next} onChange={e=>setForm(p=>({...p,next:e.target.value}))}/></div>
              <div style={{ gridColumn:"1/-1" }}><div style={S.lbl}>Notes</div><input style={S.input} value={form.notes} onChange={e=>setForm(p=>({...p,notes:e.target.value}))}/></div>
            </div>
            <div style={{ display:"flex", gap:8 }}>
              <button type="submit" style={S.pbtn}>Add</button>
              <button type="button" onClick={()=>setShowAdd(false)} style={S.sbtn}>Cancel</button>
            </div>
          </form>
        </div>
      )}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:10 }}>
        {STAGE_ORDER.map(stage=>{
          const meta=STAGE_META[stage];
          const cards=byStage(stage);
          return(
            <div key={stage} style={{ background:"var(--surface-1)", borderRadius:12, border:"0.5px solid var(--border)", padding:"0 0 8px" }}>
              <div style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 12px 8px" }}>
                <div style={{ width:8, height:8, borderRadius:"50%", background:meta.dot }}/>
                <span style={{ fontSize:12, fontWeight:500, color:"var(--text-primary)", textTransform:"capitalize" }}>{stage}</span>
                <span style={{ ...S.badge(meta.bg,meta.fg), marginLeft:"auto" }}>{cards.length}</span>
              </div>
              <div style={{ padding:"0 8px" }}>
                {cards.length===0&&<div style={{ fontSize:11, color:"var(--text-muted)", textAlign:"center", padding:"12px 0" }}>Empty</div>}
                {cards.map(p=>(
                  <div key={p.id} style={{ ...S.card, marginBottom:6 }}>
                    <div style={{ fontSize:12, fontWeight:500, color:"var(--text-primary)", marginBottom:4 }}>{p.org}</div>
                    {p.contact&&<div style={{ fontSize:11, color:"var(--text-secondary)", marginBottom:4 }}>{p.contact}</div>}
                    {p.notes&&<div style={{ fontSize:11, color:"var(--text-muted)", marginBottom:6, lineHeight:1.4 }}>{p.notes}</div>}
                    {p.next&&<div style={{ ...S.badge(T.tealL,T.tealD), fontSize:10, marginBottom:6, display:"inline-flex" }}>
                      <i className="ti ti-calendar" style={{ fontSize:10 }} aria-hidden="true"/>{p.next}
                    </div>}
                    <div style={{ display:"flex", gap:4, flexWrap:"wrap", marginTop:4 }}>
                      {STAGE_ORDER.filter(s=>s!==stage).slice(0,2).map(s=>(
                        <button key={s} onClick={()=>move(p.id,s)}
                          style={{ fontSize:10, padding:"2px 7px", borderRadius:6, border:"0.5px solid var(--border-strong)", background:"transparent", color:"var(--text-muted)", cursor:"pointer" }}>
                          → {s}
                        </button>
                      ))}
                      <button onClick={()=>del(p.id)} style={{ fontSize:10, padding:"2px 6px", borderRadius:6, border:"none", background:"transparent", color:"var(--text-muted)", cursor:"pointer", marginLeft:"auto" }}>
                        <i className="ti ti-x" aria-hidden="true"/>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Contacts tab ──────────────────────────────────────────────────────────────
const CONTACT_SEED = [
  { id:1, name:"Maya Torres",   org:"Oakland Public Library", type:"partner", email:"m.torres@oaklandlibrary.org",  tags:["storytime","programs"] },
  { id:2, name:"David Williams",org:"KPFA",                   type:"media",   email:"d.williams@kpfa.org",          tags:["radio","press"] },
  { id:3, name:"Reina Chen",    org:"Oakland Unified",        type:"partner", email:"r.chen@ousd.org",              tags:["schools","workshops"] },
  { id:4, name:"Sandra Kim",    org:"NEA",                    type:"funder",  email:"s.kim@arts.gov",               tags:["grants","federal"] },
  { id:5, name:"Paul Okonkwo",  org:"Hewlett Foundation",     type:"funder",  email:"p.okonkwo@hewlett.org",        tags:["grants"] },
];
const TYPE_META = {
  partner:{ bg:T.tealL,   fg:T.tealD },
  funder: { bg:T.purpleL, fg:T.purpleD },
  media:  { bg:"#E6F1FB", fg:"#0C447C" },
  parent: { bg:T.amberL,  fg:T.amberD },
  teacher:{ bg:"#EAF3DE", fg:"#27500A" },
};
const AVATAR_BG = { partner:T.teal, funder:T.purple, media:"#378ADD", parent:T.amber, teacher:"#639922" };

function ContactsTab() {
  const [contacts, setContacts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [fType,    setFType]    = useState("all");
  const [search,   setSearch]   = useState("");
  const [showAdd,  setShowAdd]  = useState(false);
  const [form, setForm]         = useState({ name:"", org:"", type:"partner", email:"", tags:"" });

  // DB row -> local shape
  const mapContact = row => ({
    id: row.id,
    name: row.name,
    org: row.org || "",
    type: row.stakeholderType || "partner",
    email: row.email || "",
    tags: row.tags ? row.tags.split(",").map(t => t.trim()).filter(Boolean) : [],
  });

  useEffect(() => {
    fetch('/api/contacts', { credentials: 'include' })
      .then(r => r.ok ? r.json() : { contacts: [] })
      .then(data => { setContacts((data.contacts || []).map(mapContact)); setLoading(false); })
      .catch(err => { console.error('Failed to load contacts:', err); setLoading(false); });
  }, []);

  const addContact = f => {
    fetch('/api/contacts', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: f.name, org: f.org, stakeholderType: f.type, email: f.email, tags: f.tags }),
    })
      .then(r => r.json())
      .then(data => { if (data.contact) setContacts(cs => [mapContact(data.contact), ...cs]); })
      .catch(err => console.error('Failed to add contact:', err));
    setForm({ name:"", org:"", type:"partner", email:"", tags:"" });
    setShowAdd(false);
  };

  const vis=contacts.filter(c=>{
    if(fType!=="all"&&c.type!==fType)return false;
    if(search&&!c.name.toLowerCase().includes(search.toLowerCase())&&!c.org.toLowerCase().includes(search.toLowerCase()))return false;
    return true;
  });
  const del = id => {
    setContacts(cs=>cs.filter(c=>c.id!==id)); // optimistic
    fetch(`/api/contacts/${id}`, { method: 'DELETE', credentials: 'include' })
      .catch(err => console.error('Failed to delete contact:', err));
  };
  const initials=name=>name.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();

  if (loading) {
    return <div style={{ padding:"32px 0", textAlign:"center", color:"var(--text-muted, #8a8782)", fontSize:13 }}>Loading contacts…</div>;
  }

  return (
    <div>
      <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginBottom:14 }}>
        <div style={{ flex:1, position:"relative" }}>
          <i className="ti ti-search" style={{ position:"absolute", left:9, top:"50%", transform:"translateY(-50%)", fontSize:13, color:"var(--text-muted)", pointerEvents:"none" }} aria-hidden="true"/>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search contacts…"
            style={{ ...S.input, paddingLeft:30, background:"var(--surface-1)" }}/>
        </div>
        <select style={S.pillSel} value={fType} onChange={e=>setFType(e.target.value)}>
          <option value="all">All types</option>
          {Object.keys(TYPE_META).map(t=><option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
        </select>
        <button onClick={()=>setShowAdd(v=>!v)} style={S.pbtn}>
          <i className="ti ti-plus" style={{ fontSize:13 }} aria-hidden="true"/>Add contact
        </button>
      </div>
      {showAdd&&(
        <div style={{ ...S.formPanel, marginBottom:14 }}>
          <form onSubmit={e=>{e.preventDefault();addContact(form);}}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
              <div><div style={S.lbl}>Name</div><input required style={S.input} value={form.name} onChange={e=>setForm(p=>({...p,name:e.target.value}))}/></div>
              <div><div style={S.lbl}>Organization</div><input style={S.input} value={form.org} onChange={e=>setForm(p=>({...p,org:e.target.value}))}/></div>
              <div><div style={S.lbl}>Type</div>
                <select style={S.sel} value={form.type} onChange={e=>setForm(p=>({...p,type:e.target.value}))}>
                  {Object.keys(TYPE_META).map(t=><option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
                </select>
              </div>
              <div><div style={S.lbl}>Email</div><input type="email" style={S.input} value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))}/></div>
              <div style={{ gridColumn:"1/-1" }}><div style={S.lbl}>Tags (comma separated)</div>
                <input style={S.input} placeholder="community, grants…" value={form.tags} onChange={e=>setForm(p=>({...p,tags:e.target.value}))}/>
              </div>
            </div>
            <div style={{ display:"flex", gap:8 }}>
              <button type="submit" style={S.pbtn}>Add</button>
              <button type="button" onClick={()=>setShowAdd(false)} style={S.sbtn}>Cancel</button>
            </div>
          </form>
        </div>
      )}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))", gap:10 }}>
        {vis.map(c=>{
          const tm=TYPE_META[c.type]||{ bg:"#F1EFE8", fg:"#5F5E5A" };
          return(
            <div key={c.id} style={{ ...S.card, display:"flex", flexDirection:"column", gap:8 }}>
              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                <div style={{ width:38, height:38, borderRadius:"50%", background:AVATAR_BG[c.type]||"#888",
                  display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:500, color:"#fff", flexShrink:0 }}>
                  {initials(c.name)}
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:500, color:"var(--text-primary)", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{c.name}</div>
                  <div style={{ fontSize:11, color:"var(--text-secondary)", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{c.org}</div>
                </div>
                <button onClick={()=>del(c.id)} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--text-muted)", padding:0 }}>
                  <i className="ti ti-x" style={{ fontSize:13 }} aria-hidden="true"/>
                </button>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                <Badge bg={tm.bg} fg={tm.fg} label={c.type}/>
                {c.email&&<a href={`mailto:${c.email}`} style={{ fontSize:11, color:T.teal, marginLeft:"auto", textDecoration:"none", display:"flex", alignItems:"center", gap:3 }}>
                  <i className="ti ti-mail" style={{ fontSize:12 }} aria-hidden="true"/>{c.email.split("@")[0]}
                </a>}
              </div>
              {c.tags?.length>0&&(
                <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
                  {c.tags.map(tag=><span key={tag} style={{ fontSize:10, padding:"1px 6px", borderRadius:4, background:"var(--surface-1)", color:"var(--text-muted)", border:"0.5px solid var(--border)" }}>{tag}</span>)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Tickets tab (kanban) ─────────────────────────────────────────────────────
function TicketsTab() {
  const [tasks,     setTasks]    = useState([]);
  const [loading,   setLoading]  = useState(true);
  const [fSub,      setFSub]     = useState("all");
  const [fAim,      setFAim]     = useState("all");
  const [fSrc,      setFSrc]     = useState("all");
  const [fPri,      setFPri]     = useState("all");
  const [fPhase,    setFPhase]   = useState("all");
  const [sort,      setSort]     = useState("phase");
  const [search,    setSearch]   = useState("");
  const [showForm,  setShowForm] = useState(false);
  const [expandId,  setExpandId] = useState(null);
  const cycleCtx = getCycleContext(new Date());

  // Map DB row → component shape
  const mapTask = row => ({
    id:         row.id,
    title:      row.title,
    sub:        row.subsystem  || "Admin",
    aim:        row.aim        || "Sustain",
    src:        row.sourceTool || "manual",
    st:         row.status     || "todo",
    who:        row.assignee   || "",
    pri:        row.priority   || "med",
    tid:        row.link       || "",
    docLink:    row.doc_link   || "",
    date:       row.createdAt  ? row.createdAt.slice(0,10) : "",
    cyclePhase: row.cycle_phase  || "seed",
    cycleWeek:  row.cycle_week   || 1,
    phaseLabel: row.phase_label  || "",
    notes:      row.notes        || "",
  });

  useEffect(() => {
    fetch('/api/tasks', { credentials: 'include' })
      .then(r => {
        if (!r.ok) {
          console.warn('Tasks API returned', r.status);
          setLoading(false);
          return null;
        }
        return r.json();
      })
      .then(data => {
        if (!data) return;
        const rows = Array.isArray(data) ? data
                   : Array.isArray(data.tasks) ? data.tasks
                   : [];
        setTasks(rows.map(mapTask));
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load tasks:', err);
        setLoading(false);
      });
  }, []);

  const addTask = t => {
    // POST new task to API
    fetch('/api/tasks', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title:      t.title,
        subsystem:  t.sub,
        aim:        t.aim,
        sourceTool: t.src,
        status:     'todo',
        priority:   t.pri,
        assignee:   t.who,
        link:       t.tid,
        notes:      t.notes || '',
        cycle_phase:  t.cyclePhase,
        cycle_week:   t.cycleWeek,
        phase_label:  t.phaseLabel,
      }),
    })
      .then(r => r.json())
      .then(data => {
        const newTask = data.task ? mapTask(data.task) : { ...t, id: nextId++ };
        setTasks(ts => [newTask, ...ts]);
      })
      .catch(() => setTasks(ts => [{ ...t, id: nextId++ }, ...ts]));
    setShowForm(false);
  };

  const delTask = id => {
    setTasks(ts => ts.filter(t => t.id !== id));
    fetch(`/api/tasks/${id}`, {
      method: 'DELETE',
      credentials: 'include',
    }).catch(err => console.error('Failed to delete task:', err));
  };
  const moveTask = (id, st) => {
    setTasks(ts => ts.map(t => t.id === id ? {...t, st} : t));
    fetch(`/api/tasks/${id}`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: st }),
    }).catch(err => console.error('Failed to update task status:', err));
  };
  const dropTask  = (st, raw) => moveTask(+raw, st);
  const toggleExp = id  => setExpandId(p => p===id ? null : id);

  const editTask = updated => {
    // Optimistic update
    setTasks(ts => ts.map(t => t.id === updated.id ? updated : t));
    // PATCH to API
    fetch(`/api/tasks/${updated.id}`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title:       updated.title,
        subsystem:   updated.sub,
        aim:         updated.aim,
        status:      updated.st,
        assignee:    updated.who,
        doc_link:    updated.docLink,
        notes:       updated.notes,
        cycle_phase: updated.cyclePhase,
        cycle_week:  updated.cycleWeek,
      }),
    }).catch(err => console.error('Failed to save task:', err));
  };

  const visible = tasks.filter(t => {
    if (fSub   !== "all" && t.sub          !== fSub)   return false;
    if (fAim   !== "all" && t.aim          !== fAim)   return false;
    if (fSrc   !== "all" && t.src          !== fSrc)   return false;
    if (fPri   !== "all" && t.pri          !== fPri)   return false;
    if (fPhase !== "all" && t.cyclePhase   !== fPhase) return false;
    if (search && !t.title.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  }).sort((a, b) => {
    if (sort === "phase")    return (a.cycleWeek||1) - (b.cycleWeek||1);
    if (sort === "priority") { const p={high:0,med:1,low:2}; return p[a.pri]-p[b.pri]; }
    if (sort === "subsystem") return a.sub.localeCompare(b.sub);
    return b.id - a.id;
  });

  const colTasks = s => visible.filter(t => t.st === s);
  const colTotal = s => tasks.filter(t => t.st === s).length;
  const activeF  = [fSub,fAim,fSrc,fPri,fPhase].filter(v => v !== "all").length;

  // Phase progress summary
  const phaseCounts = Object.fromEntries(
    Object.keys(PHASE_META).map(ph => [ph, tasks.filter(t => t.cyclePhase===ph)])
  );

  return (
    <div>
      {loading && (
        <div style={{ padding:"32px 0", textAlign:"center", color:"var(--text-muted)", fontSize:13 }}>
          Loading tickets…
        </div>
      )}
      {!loading && <><CycleBanner ctx={cycleCtx} />

      {/* Phase progress pills */}
      {/* <div style={{ display:"flex", gap:8, marginBottom:14, flexWrap:"wrap" }}>
        {Object.entries(PHASE_META).map(([ph, meta]) => {
          const pts = phaseCounts[ph];
          const done = pts.filter(t => t.st==="done").length;
          const pct  = pts.length ? Math.round(done/pts.length*100) : 0;
          return (
            <button key={ph} onClick={() => setFPhase(fPhase===ph ? "all" : ph)}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"6px 12px", borderRadius:8,
                border:`0.5px solid ${fPhase===ph ? meta.color : "var(--border)"}`,
                background: fPhase===ph ? meta.bg : "var(--surface-2)", cursor:"pointer" }}>
              <i className={`ti ${meta.icon}`} style={{ fontSize:13, color:meta.color }} aria-hidden="true" />
              <span style={{ fontSize:12, fontWeight:500, color:meta.fg }}>Week {meta.week} · {meta.label}</span>
              <span style={{ fontSize:11, color:meta.fg, opacity:.7 }}>{done}/{pts.length}</span>
              <div style={{ width:40, height:4, borderRadius:2, background:meta.bg, overflow:"hidden" }}>
                <div style={{ width:`${pct}%`, height:"100%", background:meta.color, borderRadius:2 }} />
              </div>
            </button>
          );
        })}
      </div> */}

      {/* Toolbar */}
      <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginBottom:10 }}>
        <div style={{ flex:1, minWidth:130, position:"relative" }}>
          <i className="ti ti-search" style={{ position:"absolute", left:9, top:"50%", transform:"translateY(-50%)", fontSize:13, color:"var(--text-muted)", pointerEvents:"none" }} aria-hidden="true" />
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search tickets…"
            style={{ ...S.input, paddingLeft:30, background:"var(--surface-1)" }} />
        </div>
        {activeF > 0 && <button onClick={() => { setFSub("all"); setFAim("all"); setFSrc("all"); setFPri("all"); setFPhase("all"); }}
          style={{ ...S.sbtn, display:"flex", alignItems:"center", gap:4 }}>
          <i className="ti ti-x" style={{ fontSize:11 }} aria-hidden="true" />{activeF} filter{activeF>1?"s":""}
        </button>}
        <select value={sort} onChange={e=>setSort(e.target.value)} style={S.pillSel}>
          <option value="phase">By phase</option>
          <option value="priority">By priority</option>
          <option value="subsystem">By subsystem</option>
          <option value="created">Newest first</option>
        </select>
        <button onClick={() => { setShowForm(v=>!v); setExpandId(null); }} style={S.pbtn}>
          <i className="ti ti-plus" style={{ fontSize:13 }} aria-hidden="true" />Add ticket
        </button>
      </div>

      {/* Filter row */}
      <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", marginBottom:14,
        padding:"8px 12px", background:"var(--surface-1)", borderRadius:8 }}>
        <span style={S.lbl}>Filter</span>
        <select style={S.pillSel} value={fSub}   onChange={e=>setFSub(e.target.value)}>
          <option value="all">All subsystems</option>{SUBS.map(s=><option key={s} value={s}>{s}</option>)}
        </select>
        <select style={S.pillSel} value={fAim}   onChange={e=>setFAim(e.target.value)}>
          <option value="all">All aims</option>{AIMS.map(a=><option key={a} value={a}>{a}</option>)}
        </select>
        <select style={S.pillSel} value={fSrc}   onChange={e=>setFSrc(e.target.value)}>
          <option value="all">All sources</option>{SRCS.map(s=><option key={s} value={s}>{SRC_META[s].l}</option>)}
        </select>
        <select style={S.pillSel} value={fPri}   onChange={e=>setFPri(e.target.value)}>
          <option value="all">All priorities</option>
          <option value="high">High</option><option value="med">Med</option><option value="low">Low</option>
        </select>
        <span style={{ marginLeft:"auto", fontSize:11, color:"var(--text-muted)" }}>{visible.length} of {tasks.length}</span>
      </div>

      {showForm && <AddTaskForm onAdd={addTask} onCancel={() => setShowForm(false)} cycleCtx={cycleCtx} />}

      {/* Board */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,minmax(0,1fr))", gap:12, marginBottom:14 }}>
        {STATS.map(status => (
          <KanbanColumn key={status} status={status} tasks={colTasks(status)} totalCount={colTotal(status)}
            expandId={expandId} onToggle={toggleExp} onDelete={delTask} onMove={moveTask}
            onEdit={editTask} onDrop={raw => dropTask(status, raw)} />
        ))}
      </div>

      {/* Legend */}
      <div style={{ padding:"8px 12px", background:"var(--surface-1)", borderRadius:8,
        display:"flex", gap:14, flexWrap:"wrap", alignItems:"center" }}>
        <span style={S.lbl}>Subsystem</span>
        {SUBS.map(s => (
          <span key={s} style={{ display:"inline-flex", alignItems:"center", gap:5, fontSize:11, color:"var(--text-secondary)" }}>
            <span style={{ width:8, height:8, borderRadius:"50%", background:SUB_COLOR[s], display:"inline-block" }} />{s}
          </span>
        ))}
        <span style={{ marginLeft:"auto", fontSize:11, color:"var(--text-muted)" }}>Drag · click to expand · W# = cycle week</span>
      </div>
      </>}
    </div>
  );
}


// ── Dashboard root ────────────────────────────────────────────────────────────
const TABS = [
  { id:"projects",     label:"Projects",     icon:"ti-layout-grid" },
  { id:"tickets",      label:"Tickets",      icon:"ti-layout-kanban" },
  { id:"grants",       label:"Grants",       icon:"ti-file-description" },
  { id:"partnerships", label:"Partnerships", icon:"ti-users" },
  { id:"contacts",     label:"Stakeholders", icon:"ti-address-book" },
];

export default function Dashboard() {
  const [tab, setTab] = useState("projects");

  const CONTENT = {
    projects:     <ProjectsGrid />,
    tickets:      <TicketsTab />,
    grants:       <GrantsTab />,
    partnerships: <PartnershipsTab />,
    contacts:     <ContactsTab />,
  };

  return (
    <div style={{ fontFamily:"var(--font-sans)", color:"var(--text-primary)", padding:"0 24px 24px" }}>
      <div style={{ display:"flex", gap:0, borderBottom:"0.5px solid var(--border)", marginBottom:20 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding:"9px 16px", background:"transparent", border:"none",
              borderBottom: tab===t.id ? `2px solid ${T.teal}` : "2px solid transparent",
              color: tab===t.id ? T.teal : "var(--text-secondary)",
              fontWeight: tab===t.id ? 500 : 400, fontSize:13, cursor:"pointer",
              display:"flex", alignItems:"center", gap:6, transition:"color .12s" }}>
            <i className={`ti ${t.icon}`} style={{ fontSize:15 }} aria-hidden="true" />
            {t.label}
          </button>
        ))}
      </div>
      {CONTENT[tab]}
    </div>
  );
}